<template>
  <div class="detail">
    <BaseHeader></BaseHeader>
    <div class="content">
      <div class="content-breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/review' }">作品评审</el-breadcrumb-item>
          <el-breadcrumb-item>评审</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="info-box">
        <!-- <div>附件</div> -->
        <div class="info-text info-annex" v-if="
          info.registrationContentList != null &&
          info.registrationContentList.length > 0
        ">
          内容：
          <span class="blue cursor link" @click="clickShow(item.FilePath)" v-for="item in info.registrationContentList"
            :key="item.Id">
            点击查看<br />
          </span>
        </div>
        <div class="info-text info-annex" v-if="info.PptFileList != null && info.PptFileList.length > 0">
          PPT文件：
          <span class="blue cursor link" @click="clickShow(item.FilePath)" v-for="item in info.PptFileList"
            :key="item.Id">
            点击查看<br />
          </span>
        </div>
        <div class="info-text info-annex" v-if="
          info.multimediaMaterialsList !== undefined &&
          info.multimediaMaterialsList.length > 0
        ">
          多媒体材料：

          <span class="blue cursor link" @click="clickShow(item.FilePath)" v-for="item in info.multimediaMaterialsList"
            :key="item.Id">
            点击查看<br />
          </span>
        </div>
        <div class="info-text info-annex" v-if="!isBlank(info.ProjectApplicationList)">
          项目申请书：
          <span class="blue cursor link" @click="clickShow(item.FilePath)" v-for="item in info.ProjectApplicationList"
            :key="item.Id">
            点击查看<br />
          </span>
        </div>
        <div class="content-iframe" v-loading="loadingfranme">
          <iframe ref="Iframe" :src="path" class="iframe" v-if="workShow" @load="framLoad"></iframe>
        </div>
        <div class="demo-image__preview" v-if="isImgShow">
          <el-image style="width: 100px; height: 100px" :src="path" :previewSrcList="[path]" fit="cover">
          </el-image>
        </div>
        <div style="margin-top: 10px">
          <el-row class="">
            <span class="text" @click="showScoreTable">{{ text }}</span>
            <div class="btns">
              <el-button type="danger" class="btn-save" @click="save" plain>提交</el-button>
            </div>
          </el-row>
        </div>
        <div class="table" v-if="isShow">
          <!-- <table
            border="1"
            style="
              border-collapse: collapse;
              width: 100%;
              height: 221px;
              font-size: 13px;
              text-align: center;
            "
          >
            <tr>
              <th>评分规则</th>
              <th>总分</th>
              <th>评分标准</th>
              <th>子项分</th>
              <th>打分</th>
            </tr>
            <tbody v-for="item in data.Models" :key="item.Id">
              <tr v-for="(child, index) in item.Childs" :key="child.Id">
                <td :rowspan="item.Childs.length" v-if="index == 0">
                  {{ item.Title }}
                </td>
                <td :rowspan="item.Childs.length" v-if="index == 0">
                  {{ item.Score }}
                </td>
                <td>{{ child.Title }}</td>
                <td>
                  {{ child.Score }}
                </td>
                <td>
                  <el-input-number
                    v-model="
                      submitData.Models.find(
                        (m) => m.ScoreRuleDetailedId == child.Id
                      ).Fraction
                    "
                    :min="0"
                    :max="child.Score"
                  />
                </td>
              </tr>
              <tr v-if="isBlank(item.Childs)">
                <td>{{ item.Title }}</td>
                <td>
                  {{ item.Score }}
                </td>
                <td></td>
                <td></td>
                <td>
                  <el-input-number
                    v-model="
                      submitData.Models.find((m) => m.ScoreRuleId == item.Id)
                        .Fraction
                    "
                    :min="0"
                    :max="item.Score"
                  />
                </td>
              </tr>
            </tbody>
          </table> -->
          <el-table :data="data.Models" :span-method="objectSpanMethod" border style="width: 100%">
            <el-table-column prop="TypeName" label="类型" width="180" />
            <el-table-column prop="Title" label="评分规则" />
            <el-table-column prop="Score" label="总分" />
            <el-table-column label="打分">
              <template #default="scope">
                <el-input-number v-model="submitData.Models.find((m) => m.ScoreRuleId == scope.row.Id).Fraction
                  " :min="0" :max="scope.row.Score" />
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseHeader from "../../views/base/BaseHeader.vue";
import { reactive, ref } from "vue";
import router from "../../router";
import { GetScoreRule, SaveScore } from "../../http/score";
import { ElLoading, ElMessage, ElMessageBox } from "element-plus";
import { isBlank, isImg } from "../../utils/utils";
import {
  GetUserRegistrationForm,
  GetUserEducationReform,
} from "../../http/psychologyTemp";
import { replace } from "../../utils/replace";
export default {
  name: "Review",
  data() {
    const loadingfranme = ref(false);

    let model = JSON.parse(decodeURIComponent(router.currentRoute.value.query.model));
    let matchId = JSON.parse(decodeURIComponent(router.currentRoute.value.query.matchId));
    let submitYear = JSON.parse(
      decodeURIComponent(router.currentRoute.value.query.submitYear)
    );
    let number = ref(0);
    let path = ref();
    let text = ref("隐藏评分表");
    let isShow = ref(true);
    const cancel = () => {
      router.push("/review");
    };
    const showScoreTable = () => {
      if (isShow.value) {
        text.value = "展开评分表";
        isShow.value = false;
      } else {
        text.value = "隐藏评分表";
        isShow.value = true;
      }
    };
    let submitData = reactive({
      ForumId: model.ForumId,
      WorkId: model.WorkId,
      Models: [],
    });
    let data = reactive({
      Models: [],
    });
    let info = reactive({
      principal: {},
      registrationContentList: [],
      multimediaMaterialsList: [],
      ProjectApplicationList: [],
      PptFileList: [],
    });
    const showWork = () => {
      info.principal = {};
      info.registrationContentList = [];
      info.multimediaMaterialsList = [];
      info.Teams = [];
      info.ProjectApplicationList = {};
      info.PptFileList = [];
      if (matchId == "1") {
        GetUserRegistrationForm({
          matchId: matchId,
          forumId: model.ForumId,
          userId: model.UserId,
          submitYear: submitYear,
          RegistrationFormId: model.WorkId,
        }).then((res) => {
          if (res.IsSuccess) {
            console.log(res.Models);
            if (!isBlank(res.Models)) {
              info.registrationContentList = res.Models[0].RegistrationContentList;
              info.registrationContentList.forEach((m) => {
                m.FilePath = replace(m.FilePath);
              });
              info.multimediaMaterialsList = res.Models[0].MultimediaMaterialsList;
              info.multimediaMaterialsList.forEach((m) => {
                m.FilePath = replace(m.FilePath);
              });

              if (
                res.Models[0].PptFileList &&
                res.Models[0].PptFileList != null &&
                res.Models[0].PptFileList.length > 0
              ) {
                info.PptFileList = res.Models[0].PptFileList;
                info.PptFileList.forEach((m) => {
                  m.FilePath = replace(m.FilePath);
                });
              }
            }
          } else {
            ElMessage.error(res.ErrorMessage);
          }
        });
      } else if (matchId == "2") {
        GetUserEducationReform({
          matchId: matchId,
          forumId: model.ForumId,
          userId: model.UserId,
          submitYear: submitYear,
          // EducationReformId: model.WorkId
        }).then((res) => {
          if (res.IsSuccess) {
            if (!isBlank(res.Models)) {
              res.Models[0].ProjectApplicationList.forEach((m) => {
                m.FilePath = replace(m.FilePath);
              });
              info.ProjectApplicationList = res.Models[0].ProjectApplicationList;
            }
          } else {
            ElMessage.error(res.ErrorMessage);
          }
        });
      }
    };
    let workShow = ref(false);

    let isImgShow = ref(false);
    const clickShow = (url) => {
      this.loadingfranme = true;
      isImgShow.value = false;
      workShow.value = false;
      if (isImg(url)) {
        path.value = url;
        isImgShow.value = true;
        return;
      }
      if (
        url.indexOf(".xls") != -1 ||
        url.indexOf(".xlsx") != -1 ||
        url.indexOf(".doc") != -1 ||
        url.indexOf(".docx") != -1
      ) {
        path.value = `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(
          url
        )}`;
        workShow.value = true;
        return;
      } else if (url.indexOf(".pdf") != -1) {
        path.value = url;
        workShow.value = true;
        return;
      }
      // if (isImg(path)) {
      //   //图片操作
      //   let routeData = router.resolve({
      //     path: "/BaseImage",
      //     query: {
      //       url: encodeURIComponent(JSON.stringify(path)),
      //     },
      //   });
      //   window.open(routeData.href, "_blank");
      //   return;
      // }
      window.open(url);
    };
    const getScoreRule = async (forumId) => {
      await GetScoreRule({ ForumId: forumId }).then((res) => {
        if (res.IsSuccess) {
          data.Models = res.Models;
          if (!isBlank(data.Models)) {
            data.Models.forEach((item) => {
              // if (!isBlank(item.Childs)) {
              //   item.Childs.forEach((m) => {
              //     submitData.Models.push({
              //       ScoreRuleId: item.Id,
              //       ScoreRuleDetailedId: m.Id,
              //       Fraction: 0,
              //     });
              //   });
              submitData.Models.push({
                ScoreRuleId: item.Id,
                Fraction: 0,
              });
            });
          }
        } else {
          ElMessage.error(res.ErrorMessage);
        }
      });
    };
    getScoreRule(model.ForumId);
    let loading;
    const save = () => {
      ElMessageBox.confirm("确认提交评分吗?", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          loading = ElLoading.service({
            lock: true,
            text: "提交中······",
            background: "rgba(0, 0, 0, 0.7)",
          });
          SaveScore(submitData).then((res) => {
            if (res.IsSuccess) {
              ElMessage.success(res.SuccessMessage);
              router.push("/review");
              loading.close();
            } else {
              ElMessage.error(res.ErrorMessage);
              loading.close();
            }
          });
        })
        .catch(() => { });
    };
    let input = ref();

    const framLoad = () => {
      this.loadingfranme = false;
    };
    return {
      name: "",
      isImgShow,
      number,
      input,
      save,
      path,
      cancel,
      text,
      showScoreTable,
      isShow,
      data,
      submitData,
      clickShow,
      isBlank,
      info,
      workShow,
      showWork,
      loadingfranme,
      framLoad,
    };
  },
  mounted() {
    this.showWork();
  },
  methods: {
    objectSpanMethod(row, columnIndex) {
      if (columnIndex == 0) {
        if (row.TypeName == this.name) {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
        this.name = row.TypeName;
        let count = this.data.Models.filter((m) => m.TypeName == this.name).length;
        return {
          rowspan: count,
          colspan: 1,
        };
      }
    },
  },
  components: {
    BaseHeader,
  },
};
</script>
<style lang="scss" scoped>
.content {
  width: 800px;
  margin: 0 auto;

  .content-breadcrumb {
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #8a8a8a;
    margin-top: 15px;
  }

  .btns {
    margin-left: 600px;
    margin-right: 10px;

    .btn-save {
      width: 100px;
    }
  }

  .text {
    text-decoration: underline;
    color: #409eff;
    font-size: 13px;
    cursor: pointer;
  }

  .content-iframe {
    margin-top: 15px;
  }

  .iframe {
    width: 100%;
    height: 680px;
  }

  .table {
    margin-top: 10px;
    margin-bottom: 20px;

    >table>tr>th {
      background-color: #f9f9f9;
    }
  }

  .info-box {
    margin-top: 30px;
    margin-bottom: 30px;
  }

  .info-text {
    margin-top: 20px;
  }
}

.red {
  color: red;
}

.blue {
  color: #409eff;
}

.green {
  color: #20a474;
}

.cursor {
  cursor: pointer;
}

.link:hover {
  text-decoration: underline;
}

.demo-image__error .image-slot {
  font-size: 30px;
}

.demo-image__error .image-slot .el-icon {
  font-size: 30px;
}

.demo-image__error .el-image {
  width: 100%;
  height: 200px;
}
</style>
